var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedium = function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.885c0 2.12-.355 3.839-.793 3.839s-.794-1.72-.794-3.84.355-3.838.793-3.838S16 5.765 16 7.885M13.975 7.885c0 2.366-1.01 4.285-2.256 4.285S9.463 10.25 9.463 7.885 10.473 3.6 11.719 3.6s2.256 1.918 2.256 4.285M9.025 7.885c0 2.514-2.02 4.552-4.512 4.552C2.02 12.437 0 10.398 0 7.885 0 5.37 2.02 3.333 4.513 3.333s4.512 2.038 4.512 4.552"
  })));
};
export default SvgMedium;